/**
 * 海岸グラフ生成
 */
import color from "../../scss/color.scss";
import libCG, { str } from "./CommonGraph";

export default {
  name: "lib-coast-graph",
  getSvgGraph,
  getSvgLeftLabel,
  getSvgRightLabel,
  getSvgLegend,
  getImageGraph,
};

// グラフの風向・風速比率(40%)
const graphWindRatio = 0.4;
// グラフの潮位・波高比率(60%)
const graphWaveRatio = 0.6;
// グラフ描画領域上余白
const paddingTop = 40;
// グラフ描画領域下余白
const paddingBottom = 120;
// ラベル描画領域左余白
const paddingLeft = 50;
// ラベル描画領域右余白
const paddingRight = 50;
// グラフ間余白
const paddingMiddle = 50;
// 風向マーク高さ
const windmarkHeight = 100;
// 風速ラベル分割数
const windDivY = 4;
// 潮位・波高ラベル分割数
const waveDivY = 8;
// 風速ラベル分割数
const cycleDivY = 8;
// ラベル表示間隔
const spaceY = 2;
// 風速ラベル桁数（小数点以下）
const windLabelDisit = 0;
// 潮位・波高ラベル桁数（小数点以下）
const waveLabelDisit = 1;
// 周期ラベル桁数（小数点以下）
const cycleLabelDisit = 1;

// 凡例サイズ
const legendWidth = 660;
const legendHeightWind = 520;
const legendHeightTide = 310;
const legendHeightMaxWave = 240;
const legendHeightOnthWave = 380;
const legendPadding = 10;

// 「風向以上」文字列
const strOverWind = "風向以上";
// 「無風」文字列
const strNoWind = "無風";
// 「最大波高」文字列
const strMaxWaveTitle = "最大波高";
// 「最大波周期」文字列
const strMaxCycleTitle = "最大波周期";
// 「1/3有義波高」文字列
const strOnthWaveTitle = "1/3有義波高";
// 「1/3有義波周期」文字列
const strOnthCycleTitle = "1/3有義波周期";

// 見出し文字サイズ
const baseWindTitleSize = 44;
const baseWindTitleWeight = 500;
const baseTideTitleSize = 50;
const baseTideTitleWeight = 500;
const baseWaveTitleSize = 50;
const baseWaveTitleWeight = 500;
const titleInterval = 10;

// グラフのスタイル
const styleGraph = `<![CDATA[
  .kwg-wind-loss {
    fill: ${color.coastWindDirLossMark};
    stroke: ${color.coastWindDirLoss};
    stroke-width: 3;
  }
  .kwg-wind-mark {
    fill: ${color.coastWindDirNormalMark};
    stroke: ${color.coastWindDirNormal};
    stroke-width: 3;
  }
  .kwg-wind-speed {
    fill: ${color.coastWindSpdNormal};
    stroke: ${color.coastWindSpdNormal};
    stroke-width: 13;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-wind-caution-border {
    fill: ${color.coastWindSpdCaution};
    stroke: ${color.coastWindSpdCaution};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-wind-warning-border {
    fill: ${color.coastWindSpdWarning};
    stroke: ${color.coastWindSpdWarning};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-tide-normal {
    fill: ${color.coastTideNormal};
    stroke: ${color.coastTideNormal};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-tide-caution-border {
    fill: ${color.coastTideCaution};
    stroke: ${color.coastTideCaution};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-tide-warning-border {
    fill: ${color.coastTideWarning};
    stroke: ${color.coastTideWarning};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-maxwave-height {
    fill: ${color.coastMaxWaveHeight};
    stroke: ${color.coastMaxWaveHeight};
    stroke-width: 1;
    opacity: 0.9;
  }
  .kwg-maxwave-cycle {
    fill: ${color.coastMaxWaveCycle};
    stroke: ${color.coastMaxWaveCycle};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-onthwave-height {
    fill: ${color.coastOnthWaveHeight};
    stroke: ${color.coastOnthWaveHeight};
    stroke-width: 1;
    opacity: 0.9;
  }
  .kwg-onthwave-cycle {
    fill: ${color.coastOnthWaveCycle};
    stroke: ${color.coastOnthWaveCycle};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-wave-caution-border {
    fill: ${color.coastWaveCaution};
    stroke: ${color.coastWaveCaution};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
  .kwg-wave-warning-border {
    fill: ${color.coastWaveWarning};
    stroke: ${color.coastWaveWarning};
    stroke-width: 5;
    stroke-dasharray: 20 10;
  }
]]>`;
// 左ラベルのスタイル
const styleLeftLabel = `<![CDATA[
  .kwg-wind-label {
    fill: ${color.coastWindSpdNormal};
    font-weight: bold;
    font-size: 48px;
  }
  .kwg-wind-title {
    fill: ${color.coastWindSpdNormal};
    font-weight: TITLEWINDWEIGHT;
    font-size: TITLEWINDSIZE;
  }
  .kwg-wind-caution-marker {
    fill: ${color.coastWindSpdCaution};
    stroke: ${color.coastWindSpdCaution};
    stroke-width: 1;
  }
  .kwg-wind-warning-marker {
    fill: ${color.coastWindSpdWarning};
    stroke: ${color.coastWindSpdWarning};
    stroke-width: 1;
  }
  .kwg-wave-label {
    fill: ${color.coastTideNormal};
    font-weight: bold;
    font-size: 48px;
  }
  .kwg-tide-title {
    fill: ${color.coastTideNormal};
    font-weight: TITLETIDEWEIGHT;
    font-size: TITLETIDESIZE;
  }
  .kwg-wave-title {
    fill: ${color.coastMaxWaveHeight};
    font-weight: TITLETIDEWEIGHT;
    font-size: TITLETIDESIZE;
  }
  .kwg-tide-caution-marker {
    fill: ${color.coastTideCaution};
    stroke: ${color.coastTideCaution};
    stroke-width: 1;
  }
  .kwg-tide-warning-marker {
    fill: ${color.coastTideWarning};
    stroke: ${color.coastTideWarning};
    stroke-width: 1;
  }
  .kwg-wave-caution-marker {
    fill: ${color.coastWaveCaution};
    stroke: ${color.coastWaveCaution};
    stroke-width: 1;
  }
  .kwg-wave-warning-marker {
    fill: ${color.coastWaveWarning};
    stroke: ${color.coastWaveWarning};
    stroke-width: 1;
  }
]]>`;
// 右ラベルのスタイル
const styleRightLabel = `<![CDATA[
  .kwg-cycle-label {
    fill: ${color.coastWaveNormal};
    font-weight: bold;
    font-size: 48px;
  }
  .kwg-cycle-title {
    fill: ${color.coastWaveNormal};
    font-weight: TITLEWAVEWEIGHT;
    font-size: TITLEWAVESIZE;
  }
]]>`;
// 凡例のスタイル
const styleLegend = `<![CDATA[
  .kwg-legend-rect {
    fill: white;
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-line {
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-label {
    fill: black;
    font-weight: 500;
    font-size: 54px;
  }
  .kwg-legend-label-unit {
    fill: black;
    font-weight: 500;
    font-size: 36px;
  }
]]>`;

// 風向変換テーブル
const winddir = [
  strNoWind,
  "NNE",
  "NE",
  "ENE",
  "E",
  "ESE",
  "SE",
  "SSE",
  "S",
  "SSW",
  "SW",
  "WSW",
  "W",
  "WNW",
  "NW",
  "NNW",
  "N",
];

/**
 * SVGグラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      wnddir: 平均風向（風向コード）
 *      wndspd: 平均風速
 *      tidlvl: 潮位
 *      maxwvhght: 最大波高
 *      maxwvcycl: 最大波周期
 *      onthwvhght: 1/3有義波高
 *      onthwvcycl: 1/3有義波周期
 *    spec: 観測情報
 *      wndspd: 風速
 *        max: 風速最大値
 *        warning: 風速警戒値
 *        caution: 風速注意値
 *        min: 風速最小値
 *        title: 風速ラベル
 *        unit: 風速単位
 *      wnddir: 風向
 *        title: 風向ラベル
 *        unit: 風向単位
 *      tide: 潮位
 *        max: 潮位最大値
 *        warning: 潮位警戒値
 *        caution: 潮位注意値
 *        min: 潮位最小値
 *        title: 潮位ラベル
 *        unit: 潮位単位
 *      wave: 波高
 *        max: 波高最大値
 *        warning: 波高警戒値
 *        caution: 波高注意値
 *        min: 波高最小値
 *        title: 波高ラベル
 *        unit: 波高単位
 *      cycle: 周期
 *        max: 周期最大値
 *        min: 周期最小値
 *        title: 周期ラベル
 *        unit: 周期単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showWind: 風向・風速グラフ表示（true=表示, false=非表示）
 *    showTide: 潮位グラフ表示（true=表示, false=非表示）
 *    showMaxwave: 最大波グラフ表示（true=表示, false=非表示）
 *    showOnthwave: 1/3有義波グラフ表示（true=表示, false=非表示）
 * @return SVGグラフ
 */
function getSvgGraph(obsInfo, viewProp) {
  // svgタグ生成
  let svgGraph = libCG.makeGraphSvgTag(
    viewProp.width,
    viewProp.height,
    viewProp.isExp
  );
  // gタグ追加
  addGGraph(svgGraph, obsInfo, viewProp, false, 0);

  return svgGraph.outerHTML;
}

/**
 * グラフグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} isSvg 画像提供モード
 * @param {*} offsetY 余白の高さ
 */
function addGGraph(parent, obsInfo, viewProp, isSvg, offsetY) {
  // gタグ追加
  let g = libCG.addGraphGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleGraph);
  // グラフ表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeGraphWidth(isSvg ? false : viewProp.isExp);
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // 時刻ラベル追加
  libCG.addGraphXAxisLabelTag(
    g,
    x,
    y + h,
    w,
    obsInfo.value,
    viewProp.isExp,
    viewProp.isHour
  );

  // 風向・風速グラフ
  if (viewProp.showWind) {
    // 風向・風速グラフ表示範囲
    y = paddingTop + windmarkHeight;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showTide || viewProp.showMaxwave || viewProp.showOnthwave) {
      h = h * graphWindRatio - paddingMiddle - windmarkHeight;
    } else {
      h = h - windmarkHeight;
    }
    // 風速フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      windDivY
    );
    // 風速・風向ツールチップ追加
    addWindGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 風向マーク追加
    addWindMark(g, x, paddingTop, w, windmarkHeight, obsInfo, viewProp);
    // 風速グラフ追加
    addWindGraphLine(g, x, y, w, h, obsInfo, viewProp);
    // 風速ボーダーライン追加
    addWindGraphBorder(g, x, y, w, h, obsInfo);
  }
  // 潮位・最大波・有義波グラフ
  if (viewProp.showTide || viewProp.showMaxwave || viewProp.showOnthwave) {
    // 潮位・最大波・有義波グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showWind) {
      y = y + h * graphWindRatio + paddingMiddle;
      h = h * graphWaveRatio - paddingMiddle;
    }
    // 潮位・最大波・有義波フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      waveDivY
    );
    // 潮位・最大波・有義波ツールチップ追加
    addWaveGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 最大波高グラフ追加
    if (viewProp.showMaxwave) {
      addMaxwaveGraphBar(g, x, y, w, h, obsInfo, viewProp);
    }
    // 有義波高グラフ追加
    if (viewProp.showOnthwave) {
      addOnthwaveGraphBar(g, x, y, w, h, obsInfo, viewProp);
    }
    // 最大波周期グラフ追加
    if (viewProp.showMaxwave) {
      addMaxwaveGraphLine(g, x, y, w, h, obsInfo, viewProp);
    }
    // 有義波周期グラフ追加
    if (viewProp.showOnthwave) {
      addOnthwaveGraphLine(g, x, y, w, h, obsInfo, viewProp);
    }
    // 潮位グラフ追加
    if (viewProp.showTide) {
      addTideGraphLine(g, x, y, w, h, obsInfo, viewProp);
    }
    // 波高ボーダーライン追加
    if (viewProp.showOnthwave) {
      addWaveGraphBorder(g, x, y, w, h, obsInfo);
    }
    // 潮位ボーダーライン追加
    if (viewProp.showTide) {
      addTideGraphBorder(g, x, y, w, h, obsInfo);
    }
  }

  return g;
}

/**
 * ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addWindGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeWindTip(obsInfo, data, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 風向マークタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addWindMark(parent, left, top, width, height, obsInfo, viewProp) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let cx = left + width - 47 - (viewProp.isExp ? xs * before : 0);
  let cy = top + 40;
  let ratio = viewProp.isExp ? 1 : 6;
  let tag, title;
  let current;

  for (let index = 0; index < obsInfo.value.length; index = index + ratio) {
    current = obsInfo.value[index];
    if (current != null) {
      if (current.wnddir == null) {
        // 欠測
        tag = document.createElement("circle");
        tag.setAttribute("cx", cx);
        tag.setAttribute("cy", cy);
        tag.setAttribute("r", 28);
        tag.setAttribute("class", "kwg-wind-loss");
        title = document.createElement("title");
        title.appendChild(
          document.createTextNode(makeWindTip(obsInfo, current, true, false))
        );
        tag.appendChild(title);
        parent.appendChild(tag);
      } else {
        if (current.wnddir == 0) {
          // 無風
          tag = document.createElement("circle");
          tag.setAttribute("cx", cx);
          tag.setAttribute("cy", cy);
          tag.setAttribute("r", 28);
          tag.setAttribute("class", "kwg-wind-mark");
          title = document.createElement("title");
          title.appendChild(
            document.createTextNode(makeWindTip(obsInfo, current, true, false))
          );
          tag.appendChild(title);
          parent.appendChild(tag);
        } else if (current.wnddir < winddir.length) {
          // 風向以上
          tag = document.createElement("polygon");
          tag.setAttribute("points", "30 60 50 0 30 20 10 0");
          tag.setAttribute("class", "kwg-wind-mark");
          tag.setAttribute(
            "transform",
            "translate(" +
              (cx - 30) +
              "," +
              (cy - 30) +
              ") rotate(" +
              22.5 * current.wnddir +
              ",30,30)"
          );
          title = document.createElement("title");
          title.appendChild(
            document.createTextNode(makeWindTip(obsInfo, current, true, false))
          );
          tag.appendChild(title);
          parent.appendChild(tag);
        } else {
          // 不整値（何も表示しない）
        }
      }
    }
    cx = cx - xs * ratio;
  }
}

/**
 * 風速線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addWindGraphLine(parent, left, top, width, height, obsInfo, viewProp) {
  let cls = "kwg-wind-speed";
  let max = obsInfo.spec.wndspd.max;
  let min = obsInfo.spec.wndspd.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;
    if (
      current == null ||
      current.wndspd == null ||
      current.wndspd > max ||
      current.wndspd < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.wndspd == null ||
      next.wndspd > max ||
      next.wndspd < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.wndspd - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.wndspd - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeWindTip(obsInfo, next, false, true)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWindTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWindTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.wndspd != null &&
    current.wndspd <= max &&
    current.wndspd >= min
  ) {
    x1 = x - xs - 1;
    y1 = bottom - ys * (current.wndspd - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWindTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWindTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 風速ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addWindGraphBorder(parent, left, top, width, height, obsInfo) {
  let spec = obsInfo.spec.wndspd;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.caution != null && spec.caution <= max && spec.caution >= min) {
    y = bottom - ys * (spec.caution - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-wind-caution-border"
    );
    parent.appendChild(tag);
  }
  if (spec.warning != null && spec.warning <= max && spec.warning >= min) {
    y = bottom - ys * (spec.warning - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-wind-warning-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * 風向・風速ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} showWinddir 風向表示
 * @param {*} showWindspd 風速表示
 */
function makeWindTip(obsInfo, data, showWinddir, showWindspd) {
  let spec = obsInfo.spec.wnddir;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 風向
  if (showWinddir) {
    tip = tip + str.CRLF + spec.title + str.Sept;
    if (data.wnddir != null) {
      tip = tip + winddir[data.wnddir];
    } else {
      tip = tip + str.None;
    }
  }
  // 風速
  if (showWindspd) {
    spec = obsInfo.spec.wndspd;
    tip = tip + str.CRLF + spec.title + str.Sept;
    if (data.wndspd != null) {
      tip = tip + data.wndspd + spec.unit;
    } else {
      tip = tip + str.None;
    }
  }

  return tip;
}

/**
 * ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addWaveGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeWaveTip(
          obsInfo,
          data,
          viewProp.showTide,
          viewProp.showMaxwave,
          viewProp.showMaxwave,
          viewProp.showOnthwave,
          viewProp.showOnthwave
        )
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 最大波高棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addMaxwaveGraphBar(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let max = Math.max(obsInfo.spec.wave.max, obsInfo.spec.tide.max);
  let min = Math.min(obsInfo.spec.wave.min, obsInfo.spec.tide.min);

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let ys = height / (max - min);
  let y, h;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (
      data == null ||
      data.maxwvhght == null ||
      data.maxwvhght > max ||
      data.maxwvhght < min
    ) {
      continue;
    }
    y = bottom - ys * (data.maxwvhght - min);
    h = bottom - y - 1;
    tag = libCG.makeBarGraphSvgTag(
      x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
      y,
      w,
      h,
      "kwg-maxwave-height",
      makeWaveTip(
        obsInfo,
        data,
        viewProp.showTide,
        viewProp.showMaxwave,
        viewProp.showMaxwave,
        viewProp.showOnthwave,
        viewProp.showOnthwave
      )
    );
    parent.appendChild(tag);
  }
}

/**
 * 1/3有義波高棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addOnthwaveGraphBar(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let max = Math.max(obsInfo.spec.wave.max, obsInfo.spec.tide.max);
  let min = Math.min(obsInfo.spec.wave.min, obsInfo.spec.tide.min);

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let ys = height / (max - min);
  let y, h;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (
      data == null ||
      data.onthwvhght == null ||
      data.onthwvhght > max ||
      data.onthwvhght < min
    ) {
      continue;
    }
    y = bottom - ys * (data.onthwvhght - min);
    h = bottom - y - 1;
    tag = libCG.makeBarGraphSvgTag(
      x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
      y,
      w,
      h,
      "kwg-onthwave-height",
      makeWaveTip(
        obsInfo,
        data,
        viewProp.showTide,
        viewProp.showMaxwave,
        viewProp.showMaxwave,
        viewProp.showOnthwave,
        viewProp.showOnthwave
      )
    );
    parent.appendChild(tag);
  }
}

/**
 * 最大波周期線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addMaxwaveGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-maxwave-cycle";
  let max = obsInfo.spec.cycle.max;
  let min = obsInfo.spec.cycle.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;
    if (
      current == null ||
      current.maxwvcycl == null ||
      current.maxwvcycl > max ||
      current.maxwvcycl < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.maxwvcycl == null ||
      next.maxwvcycl > max ||
      next.maxwvcycl < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.maxwvcycl - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.maxwvcycl - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeWaveTip(obsInfo, next, false, false, true, false, false)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, false, false, true, false, false)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, false, false, true, false, false)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.maxwvcycl != null &&
    current.maxwvcycl <= max &&
    current.maxwvcycl >= min
  ) {
    x = x - xs;
    x1 = x - 1;
    y1 = bottom - ys * (current.maxwvcycl - min);
    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, false, false, true, false, false)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, false, false, true, false, false)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 1/3有義波周期線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addOnthwaveGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-onthwave-cycle";
  let max = obsInfo.spec.cycle.max;
  let min = obsInfo.spec.cycle.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.onthwvcycl == null ||
      current.onthwvcycl > max ||
      current.onthwvcycl < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.onthwvcycl == null ||
      next.onthwvcycl > max ||
      next.onthwvcycl < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.onthwvcycl - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.onthwvcycl - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeWaveTip(obsInfo, next, false, false, false, false, true)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, false, false, false, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, false, false, false, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.onthwvcycl != null &&
    current.onthwvcycl <= max &&
    current.onthwvcycl >= min
  ) {
    x1 = x - xs - 1;
    y1 = bottom - ys * (current.onthwvcycl - min);
    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, false, false, false, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, false, false, false, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 潮位線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addTideGraphLine(parent, left, top, width, height, obsInfo, viewProp) {
  let cls = "kwg-tide-normal";
  let max = Math.max(obsInfo.spec.wave.max, obsInfo.spec.tide.max);
  let min = Math.min(obsInfo.spec.wave.min, obsInfo.spec.tide.min);

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.tidlvl == null ||
      current.tidlvl > max ||
      current.tidlvl < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.tidlvl == null ||
      next.tidlvl > max ||
      next.tidlvl < min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.tidlvl - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.tidlvl - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeWaveTip(obsInfo, next, true, false, false, false, false)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, true, false, false, false, false)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, true, false, false, false, false)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.tidlvl != null &&
    current.tidlvl <= max &&
    current.tidlvl >= min
  ) {
    x1 = x - xs - 1;
    y1 = bottom - ys * (current.tidlvl - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeWaveTip(obsInfo, current, true, false, false, false, false)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeWaveTip(obsInfo, current, true, false, false, false, false)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 波高ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addWaveGraphBorder(parent, left, top, width, height, obsInfo) {
  let spec = obsInfo.spec.wave;
  let max = Math.max(obsInfo.spec.wave.max, obsInfo.spec.tide.max);
  let min = Math.min(obsInfo.spec.wave.min, obsInfo.spec.tide.min);

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.caution != null && spec.caution <= max && spec.caution >= min) {
    y = bottom - ys * (spec.caution - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-wave-caution-border"
    );
    parent.appendChild(tag);
  }
  if (spec.warning != null && spec.warning <= max && spec.warning >= min) {
    y = bottom - ys * (spec.warning - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-wave-warning-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * 潮位ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addTideGraphBorder(parent, left, top, width, height, obsInfo) {
  let spec = obsInfo.spec.tide;
  let max = Math.max(obsInfo.spec.wave.max, obsInfo.spec.tide.max);
  let min = Math.min(obsInfo.spec.wave.min, obsInfo.spec.tide.min);

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.caution != null && spec.caution <= max && spec.caution >= min) {
    y = bottom - ys * (spec.caution - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-tide-caution-border"
    );
    parent.appendChild(tag);
  }
  if (spec.warning != null && spec.warning <= max && spec.warning >= min) {
    y = bottom - ys * (spec.warning - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-tide-warning-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * 潮位・最大波・有義波ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} showTide 潮位表示
 * @param {*} showMaxwave 最大波高表示
 * @param {*} showMaxcycle 最大波周期表示
 * @param {*} showOnthwave 1/3有義波高表示
 * @param {*} showOnthcycle 1/3有義波周期表示
 */
function makeWaveTip(
  obsInfo,
  data,
  showTide,
  showMaxwave,
  showMaxcycle,
  showOnthwave,
  showOnthcycle
) {
  let spec = obsInfo.spec;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 潮位
  if (showTide) {
    tip = tip + str.CRLF + spec.tide.title + str.Sept;
    if (data.tidlvl != null) {
      tip = tip + data.tidlvl + spec.tide.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 最大波高
  if (showMaxwave) {
    tip = tip + str.CRLF + strMaxWaveTitle + str.Sept;
    if (data.maxwvhght != null) {
      tip = tip + data.maxwvhght + spec.wave.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 最大波周期
  if (showMaxcycle) {
    tip = tip + str.CRLF + strMaxCycleTitle + str.Sept;
    if (data.maxwvcycl != null) {
      tip = tip + data.maxwvcycl + spec.cycle.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 1/3有義波高
  if (showOnthwave) {
    tip = tip + str.CRLF + strOnthWaveTitle + str.Sept;
    if (data.onthwvhght != null) {
      tip = tip + data.onthwvhght + spec.wave.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 1/3有義波周期
  if (showOnthcycle) {
    tip = tip + str.CRLF + strOnthCycleTitle + str.Sept;
    if (data.onthwvcycl != null) {
      tip = tip + data.onthwvcycl + spec.cycle.unit;
    } else {
      tip = tip + str.None;
    }
  }

  return tip;
}

/********** **********/

/**
 * SVG左軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      wnddir: 平均風向（風向コード）
 *      wndspd: 平均風速
 *      tidlvl: 潮位
 *      maxwvhght: 最大波高
 *      maxwvcycl: 最大波周期
 *      onthwvhght: 1/3有義波高
 *      onthwvcycl: 1/3有義波周期
 *    spec: 観測情報
 *      wndspd: 風速
 *        max: 風速最大値
 *        warning: 風速警戒値
 *        caution: 風速注意値
 *        min: 風速最小値
 *        title: 風速ラベル
 *        unit: 風速単位
 *      wnddir: 風向
 *        title: 風向ラベル
 *        unit: 風向単位
 *      tide: 潮位
 *        max: 潮位最大値
 *        warning: 潮位警戒値
 *        caution: 潮位注意値
 *        min: 潮位最小値
 *        title: 潮位ラベル
 *        unit: 潮位単位
 *      wave: 波高
 *        max: 波高最大値
 *        warning: 波高警戒値
 *        caution: 波高注意値
 *        min: 波高最小値
 *        title: 波高ラベル
 *        unit: 波高単位
 *      cycle: 周期
 *        max: 周期最大値
 *        min: 周期最小値
 *        title: 周期ラベル
 *        unit: 周期単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showWind: 風向・風速グラフ表示（true=表示, false=非表示）
 *    showTide: 潮位グラフ表示（true=表示, false=非表示）
 *    showMaxwave: 最大波グラフ表示（true=表示, false=非表示）
 *    showOnthwave: 1/3有義波グラフ表示（true=表示, false=非表示）
 * @return SVG左ラベル
 */
function getSvgLeftLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgLeftLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGLeftLabel(svgLeftLabel, obsInfo, viewProp, 0);

  return svgLeftLabel.outerHTML;
}

/**
 * 左ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGLeftLabel(parent, obsInfo, viewProp, offsetY) {
  let spec = obsInfo.spec;
  let tip;
  // 海岸左ラベル表示範囲
  let x = paddingLeft;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingLeft;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addLeftLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // styleタグ追加
  let style = String(styleLeftLabel);
  const sizeWind = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseWindTitleSize,
    baseWindTitleWeight
  );
  const sizeTide = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseTideTitleSize,
    baseTideTitleWeight
  );
  style = style.replace(/TITLEWINDWEIGHT/g, sizeWind.weight);
  style = style.replace(/TITLEWINDSIZE/g, sizeWind.size + "px");
  style = style.replace(/TITLETIDEWEIGHT/g, sizeTide.weight);
  style = style.replace(/TITLETIDESIZE/g, sizeTide.size + "px");
  libCG.addStyleTag(g, style);
  // 風向・風速グラフ
  if (viewProp.showWind) {
    // 風向・風速グラフ表示範囲
    y = paddingTop + windmarkHeight;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showTide || viewProp.showMaxwave || viewProp.showOnthwave) {
      h = h * graphWindRatio - paddingMiddle - windmarkHeight;
    } else {
      h = h - windmarkHeight;
    }
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.wndspd.max,
      spec.wndspd.min,
      windLabelDisit,
      windDivY,
      spaceY,
      "kwg-wind-label"
    );
    // ラベルタグ追加
    libCG.addLeftLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.wndspd.title,
      spec.wndspd.unit,
      "kwg-wind-title"
    );
    // 風速注意値ボーダーマーカータグ追加
    if (
      spec.wndspd.caution != null &&
      spec.wndspd.caution <= spec.wndspd.max &&
      spec.wndspd.caution >= spec.wndspd.min
    ) {
      tip =
        spec.wndspd.title +
        str.Caution +
        str.Sept +
        spec.wndspd.caution +
        spec.wndspd.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.wndspd.max,
        spec.wndspd.min,
        spec.wndspd.caution,
        tip,
        "kwg-wind-caution-marker"
      );
    }
    // 風速警戒値ボーダーマーカータグ追加
    if (
      spec.wndspd.warning != null &&
      spec.wndspd.warning <= spec.wndspd.max &&
      spec.wndspd.warning >= spec.wndspd.min
    ) {
      tip =
        spec.wndspd.title +
        str.Warning +
        str.Sept +
        spec.wndspd.warning +
        spec.wndspd.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.wndspd.max,
        spec.wndspd.min,
        spec.wndspd.warning,
        tip,
        "kwg-wind-warning-marker"
      );
    }
  }
  // 潮位・最大波・有義波グラフ
  if (viewProp.showTide || viewProp.showMaxwave || viewProp.showOnthwave) {
    // 潮位・最大波・有義波グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showWind) {
      y = y + h * graphWindRatio + paddingMiddle;
      h = h * graphWaveRatio - paddingMiddle;
    }
    let max = Math.max(spec.wave.max, spec.tide.max);
    let min = Math.min(spec.wave.min, spec.tide.min);
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      max,
      min,
      waveLabelDisit,
      waveDivY,
      spaceY,
      "kwg-wave-label"
    );
    // ラベルタグ追加
    let interval = 0;
    if (viewProp.showTide) {
      libCG.addLeftLabelYAxisTitleTag(
        g,
        x,
        y,
        w,
        h,
        spec.tide.title,
        spec.tide.unit,
        "kwg-tide-title"
      );
      interval = titleInterval + sizeTide.size;
    }
    if (viewProp.showMaxwave || viewProp.showOnthwave) {
      let title = "";
      if (viewProp.showMaxwave && viewProp.showOnthwave) {
        title = spec.wave.title;
      } else if (viewProp.showMaxwave) {
        title = strMaxWaveTitle;
      } else {
        title = strOnthWaveTitle;
      }

      libCG.addLeftLabelYAxisTitleTag(
        g,
        x + interval,
        y,
        w,
        h,
        // spec.wave.title,
        title,
        spec.wave.unit,
        "kwg-wave-title"
      );
    }
    // 波高注意値ボーダーマーカータグ追加
    if (
      viewProp.showOnthwave &&
      spec.wave.caution != null &&
      spec.wave.caution <= max &&
      spec.wave.caution >= min
    ) {
      tip =
        spec.wave.title +
        str.Caution +
        str.Sept +
        spec.wave.caution +
        spec.wave.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        max,
        min,
        spec.wave.caution,
        tip,
        "kwg-wave-caution-marker"
      );
    }
    // 波高警戒値ボーダーマーカータグ追加
    if (
      viewProp.showOnthwave &&
      spec.wave.warning != null &&
      spec.wave.warning <= max &&
      spec.wave.warning >= min
    ) {
      tip =
        spec.wave.title +
        str.Warning +
        str.Sept +
        spec.wave.warning +
        spec.wave.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        max,
        min,
        spec.wave.warning,
        tip,
        "kwg-wave-warning-marker"
      );
    }
    // 潮位注意値ボーダーマーカータグ追加
    if (
      viewProp.showTide &&
      spec.tide.caution != null &&
      spec.tide.caution <= max &&
      spec.tide.caution >= min
    ) {
      tip =
        spec.tide.title +
        str.Caution +
        str.Sept +
        spec.tide.caution +
        spec.tide.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        max,
        min,
        spec.tide.caution,
        tip,
        "kwg-tide-caution-marker"
      );
    }
    // 潮位警戒値ボーダーマーカータグ追加
    if (
      viewProp.showTide &&
      spec.tide.warning != null &&
      spec.tide.warning <= max &&
      spec.tide.warning >= min
    ) {
      tip =
        spec.tide.title +
        str.Warning +
        str.Sept +
        spec.tide.warning +
        spec.tide.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        max,
        min,
        spec.tide.warning,
        tip,
        "kwg-tide-warning-marker"
      );
    }
  }

  return g;
}

/********** **********/

/**
 * SVG右軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      wnddir: 平均風向（風向コード）
 *      wndspd: 平均風速
 *      tidlvl: 潮位
 *      maxwvhght: 最大波高
 *      maxwvcycl: 最大波周期
 *      onthwvhght: 1/3有義波高
 *      onthwvcycl: 1/3有義波周期
 *    spec: 観測情報
 *      wndspd: 風速
 *        max: 風速最大値
 *        warning: 風速警戒値
 *        caution: 風速注意値
 *        min: 風速最小値
 *        title: 風速ラベル
 *        unit: 風速単位
 *      wnddir: 風向
 *        title: 風向ラベル
 *        unit: 風向単位
 *      tide: 潮位
 *        max: 潮位最大値
 *        warning: 潮位警戒値
 *        caution: 潮位注意値
 *        min: 潮位最小値
 *        title: 潮位ラベル
 *        unit: 潮位単位
 *      wave: 波高
 *        max: 波高最大値
 *        warning: 波高警戒値
 *        caution: 波高注意値
 *        min: 波高最小値
 *        title: 波高ラベル
 *        unit: 波高単位
 *      cycle: 周期
 *        max: 周期最大値
 *        min: 周期最小値
 *        title: 周期ラベル
 *        unit: 周期単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showWind: 風向・風速グラフ表示（true=表示, false=非表示）
 *    showTide: 潮位グラフ表示（true=表示, false=非表示）
 *    showMaxwave: 最大波グラフ表示（true=表示, false=非表示）
 *    showOnthwave: 1/3有義波グラフ表示（true=表示, false=非表示）
 * @return SVG右ラベル
 */
function getSvgRightLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgRightLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGRightLabel(svgRightLabel, obsInfo, viewProp, 0);

  return svgRightLabel.outerHTML;
}

/**
 * 右ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGRightLabel(parent, obsInfo, viewProp, offsetY) {
  // 海岸右ラベル表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingRight;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addRightLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // styleタグ追加
  let style = String(styleRightLabel);
  const sizeWave = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseWaveTitleSize,
    baseWaveTitleWeight
  );
  style = style.replace(/TITLEWAVEWEIGHT/g, sizeWave.weight);
  style = style.replace(/TITLEWAVESIZE/g, sizeWave.size + "px");
  libCG.addStyleTag(g, style);
  // 最大波・有義波グラフ
  if (viewProp.showMaxwave || viewProp.showOnthwave) {
    // 最大波・有義波グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showWind) {
      y = y + h * graphWindRatio + paddingMiddle;
      h = h * graphWaveRatio - paddingMiddle;
    }
    let spec = obsInfo.spec.cycle;
    // 目盛タグ追加
    libCG.addRightLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.max,
      spec.min,
      cycleLabelDisit,
      cycleDivY,
      spaceY,
      "kwg-cycle-label"
    );

    let title = "";
    if (viewProp.showMaxwave && viewProp.showOnthwave) {
      title = spec.title;
    } else if (viewProp.showMaxwave) {
      title = strMaxCycleTitle;
    } else {
      title = strOnthCycleTitle;
    }
    // ラベルタグ追加
    libCG.addRightLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      // spec.title,
      title,
      spec.unit,
      "kwg-cycle-title"
    );
  }

  return g;
}

/********** **********/

/**
 * SVG凡例取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      wnddir: 平均風向（風向コード）
 *      wndspd: 平均風速
 *      tidlvl: 潮位
 *      maxwvhght: 最大波高
 *      maxwvcycl: 最大波周期
 *      onthwvhght: 1/3有義波高
 *      onthwvcycl: 1/3有義波周期
 *    spec: 観測情報
 *      wndspd: 風速
 *        max: 風速最大値
 *        warning: 風速警戒値
 *        caution: 風速注意値
 *        min: 風速最小値
 *        title: 風速ラベル
 *        unit: 風速単位
 *      wnddir: 風向
 *        title: 風向ラベル
 *        unit: 風向単位
 *      tide: 潮位
 *        max: 潮位最大値
 *        warning: 潮位警戒値
 *        caution: 潮位注意値
 *        min: 潮位最小値
 *        title: 潮位ラベル
 *        unit: 潮位単位
 *      wave: 波高
 *        max: 波高最大値
 *        warning: 波高警戒値
 *        caution: 波高注意値
 *        min: 波高最小値
 *        title: 波高ラベル
 *        unit: 波高単位
 *      cycle: 周期
 *        max: 周期最大値
 *        min: 周期最小値
 *        title: 周期ラベル
 *        unit: 周期単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showWind: 風向・風速グラフ表示（true=表示, false=非表示）
 *    showTide: 潮位グラフ表示（true=表示, false=非表示）
 *    showMaxwave: 最大波グラフ表示（true=表示, false=非表示）
 *    showOnthwave: 1/3有義波グラフ表示（true=表示, false=非表示）
 * @return SVG凡例
 */
function getSvgLegend(obsInfo, viewProp) {
  let x = legendWidth;
  if (
    viewProp.showWind &&
    (viewProp.showTide || viewProp.showMaxwave || viewProp.showOnthwave)
  ) {
    x = legendWidth * 2;
  }
  let y = 0;
  if (viewProp.showTide) {
    y = y + legendHeightTide;
  }
  if (viewProp.showMaxwave) {
    y = y + legendHeightMaxWave;
  }
  if (viewProp.showOnthwave) {
    y = y + legendHeightOnthWave;
  }
  if (viewProp.showWind && y < legendHeightWind) {
    y = legendHeightWind;
  }

  // svgタグ生成
  let svgLegend = libCG.makeLegendSvgTag(
    viewProp.width,
    viewProp.height,
    x + legendPadding,
    y + legendPadding
  );
  // gタグ追加
  addGLegend(svgLegend, obsInfo, viewProp, true);

  return svgLegend.outerHTML;
}

/**
 * 凡例グループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} isRows 並列表示
 */
function addGLegend(parent, obsInfo, viewProp, isRows) {
  let tag;
  let spec = obsInfo.spec;
  let w = legendWidth;
  let h = legendHeightWind;
  let x = isRows ? legendWidth : 0;
  let y = 5;
  // gタグ追加
  let g = libCG.addLegendGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleLegend);

  // 風向・風速凡例
  if (viewProp.showWind) {
    if (!viewProp.showTide && !viewProp.showMaxwave && !viewProp.showOnthwave) {
      x = 0;
    }
    // 枠
    tag = libCG.makeLegendFrame(x + 5, 5, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    y = 75;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.wnddir.title + str.Div + spec.wndspd.title,
      "kwg-legend-label",
      null,
      null
    );
    // 風向以上
    tag = document.createElement("polygon");
    tag.setAttribute("points", "30 60 50 0 30 20 10 0");
    tag.setAttribute("class", "kwg-wind-mark");
    tag.setAttribute(
      "transform",
      "translate(" + (x + 60) + "," + (y - 55) + ")"
    );
    g.appendChild(tag);
    y = libCG.addLegendGraph(g, x, y, strOverWind, "kwg-legend-label");
    // 無風
    tag = document.createElement("circle");
    tag.setAttribute("cx", x + 90);
    tag.setAttribute("cy", y - 20);
    tag.setAttribute("r", 28);
    tag.setAttribute("class", "kwg-wind-mark");
    g.appendChild(tag);
    y = libCG.addLegendGraph(g, x, y, strNoWind, "kwg-legend-label");
    // 欠測
    tag = document.createElement("circle");
    tag.setAttribute("cx", x + 90);
    tag.setAttribute("cy", y - 20);
    tag.setAttribute("r", 28);
    tag.setAttribute("class", "kwg-wind-loss");
    g.appendChild(tag);
    y = libCG.addLegendGraph(g, x, y, str.Loss, "kwg-legend-label");
    y = libCG.addLegendLineGraphUnit(
      g,
      x,
      y,
      "kwg-wind-speed",
      spec.wndspd.title,
      "kwg-legend-label",
      spec.wndspd.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-wind-warning-border",
      spec.wndspd.title + str.Warning,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-wind-caution-border",
      spec.wndspd.title + str.Caution,
      "kwg-legend-label"
    );
  }
  if (isRows) {
    x = 0;
    y = 5;
  }
  // 潮位凡例
  if (viewProp.showTide) {
    w = legendWidth;
    h = legendHeightTide;
    // 枠
    tag = libCG.makeLegendFrame(x + 5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 潮位
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.tide.title,
      "kwg-legend-label",
      null,
      null
    );
    y = libCG.addLegendLineGraphUnit(
      g,
      x,
      y,
      "kwg-tide-normal",
      spec.tide.title,
      "kwg-legend-label",
      spec.tide.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-tide-warning-border",
      spec.tide.title + str.Warning,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-tide-caution-border",
      spec.tide.title + str.Caution,
      "kwg-legend-label"
    );
    y = y - 40;
  }
  // 最大波凡例
  if (viewProp.showMaxwave) {
    w = legendWidth;
    h = legendHeightMaxWave;
    // 枠
    tag = libCG.makeLegendFrame(x + 5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 最大波
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      strMaxWaveTitle,
      "kwg-legend-label",
      null,
      null
    );
    y = libCG.addLegendBarGraphUnit(
      g,
      x,
      y,
      "kwg-maxwave-height",
      strMaxWaveTitle,
      "kwg-legend-label",
      spec.wave.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraphUnit(
      g,
      x,
      y,
      "kwg-maxwave-cycle",
      strMaxCycleTitle,
      "kwg-legend-label",
      spec.cycle.unit,
      "kwg-legend-label-unit"
    );
    y = y - 40;
  }
  // 1/3有義波凡例
  if (viewProp.showOnthwave) {
    w = legendWidth;
    h = legendHeightOnthWave;
    // 枠
    tag = libCG.makeLegendFrame(x + 5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 1/3有義波
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      strOnthWaveTitle,
      "kwg-legend-label",
      null,
      null
    );
    y = libCG.addLegendBarGraphUnit(
      g,
      x,
      y,
      "kwg-onthwave-height",
      strOnthWaveTitle,
      "kwg-legend-label",
      spec.wave.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraphUnit(
      g,
      x,
      y,
      "kwg-onthwave-cycle",
      strOnthCycleTitle,
      "kwg-legend-label",
      spec.cycle.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-wave-warning-border",
      spec.wave.title + str.Warning,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-wave-caution-border",
      spec.wave.title + str.Caution,
      "kwg-legend-label"
    );
    y = y - 40;
  }

  return g;
}

/********** **********/

/**
 * 画像グラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      wnddir: 平均風向（風向コード）
 *      wndspd: 平均風速
 *      tidlvl: 潮位
 *      maxwvhght: 最大波高
 *      maxwvcycl: 最大波周期
 *      onthwvhght: 1/3有義波高
 *      onthwvcycl: 1/3有義波周期
 *    spec: 観測情報
 *      obs: 観測所情報
 *        obsNm: 観測所名
 *        rsysNm: 水系名
 *        rvrNm: 河川名
 *        obsDt: 観測日時
 *      wndspd: 風速
 *        max: 風速最大値
 *        warning: 風速警戒値
 *        caution: 風速注意値
 *        min: 風速最小値
 *        title: 風速ラベル
 *        unit: 風速単位
 *      wnddir: 風向
 *        title: 風向ラベル
 *        unit: 風向単位
 *      tide: 潮位
 *        max: 潮位最大値
 *        warning: 潮位警戒値
 *        caution: 潮位注意値
 *        min: 潮位最小値
 *        title: 潮位ラベル
 *        unit: 潮位単位
 *      wave: 波高
 *        max: 波高最大値
 *        warning: 波高警戒値
 *        caution: 波高注意値
 *        min: 波高最小値
 *        title: 波高ラベル
 *        unit: 波高単位
 *      cycle: 周期
 *        max: 周期最大値
 *        min: 周期最小値
 *        title: 周期ラベル
 *        unit: 周期単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    isInfo: 観測所情報表示（true=表示, false=非表示）
 *    isLegend: 凡例表示（true=表示, false=非表示）
 *    showWind: 風向・風速グラフ表示（true=表示, false=非表示）
 *    showTide: 潮位グラフ表示（true=表示, false=非表示）
 *    showMaxwave: 最大波グラフ表示（true=表示, false=非表示）
 *    showOnthwave: 1/3有義波グラフ表示（true=表示, false=非表示）
 * @param callback 画像生成後に呼び出すコールバック関数
 * @return SVGオブジェクト
 */
function getImageGraph(obsInfo, viewProp, callback) {
  let g;
  let offsetX;
  let offsetY = 0;
  let lw = viewProp.isLegend ? legendWidth + legendPadding : 0;
  let graphProp = Object.assign({}, viewProp);
  graphProp.width = libCG.computeImageGraphWidth(viewProp.width, lw);

  // svgタグ生成
  let svgImage = libCG.makeImageSvgTag(viewProp.width, viewProp.height, lw);

  // 観測所情報追加
  if (viewProp.isInfo && obsInfo.spec.obs != null) {
    let obs = obsInfo.spec.obs;
    offsetY = libCG.addObsInfo(
      svgImage,
      obs.obsNm,
      obs.rsysNm,
      obs.rvrNm,
      obs.obsDt
    );
  }

  // 左ラベル追加
  g = addGLeftLabel(svgImage, obsInfo, graphProp, offsetY);
  g.setAttribute("transform", "translate(0," + offsetY + ")");

  // グラフ追加
  g = addGGraph(svgImage, obsInfo, graphProp, true, offsetY);
  offsetX = libCG.computeLabelWidth();
  g.setAttribute("transform", "translate(" + offsetX + "," + offsetY + ")");

  // 右ラベル追加
  g = addGRightLabel(svgImage, obsInfo, graphProp, offsetY);
  offsetX = libCG.computeLabelWidth() + libCG.computeGraphWidth(false);
  g.setAttribute("transform", "translate(" + offsetX + "," + offsetY + ")");

  // 凡例追加
  if (viewProp.isLegend) {
    graphProp.width = libCG.computeImageLegendWidth(
      viewProp.width,
      legendWidth
    );
    g = addGLegend(svgImage, obsInfo, graphProp, false);
    offsetX = libCG.computeLabelWidth() * 2 + libCG.computeGraphWidth(false);
    g.setAttribute(
      "transform",
      "translate(" + offsetX + "," + (offsetY + 50) + ")"
    );
  }

  // 画像要素返却
  if (callback != null) {
    callback(svgImage);
  }

  return svgImage;
}
